.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #657b83;
	--pce-bg: #fdf6e3;
	--pce-widget-border: #c2c2c2;
	--pce-widget-bg: #f9f0d7;
	--pce-widget-color: #405359;
	--pce-widget-color-active: #000;
	--pce-widget-color-options: #4f5f64;
	--pce-widget-bg-input: #fdf6e3;
	--pce-widget-bg-hover: #b8b8b84f;
	--pce-widget-bg-active: #6fa3b34d;
	--pce-widget-focus: #4bafce;
	--pce-search-match: #eb5e0054;
	--pce-widget-bg-error: #f2dede;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #eee8d5;
	--pce-selection-match: #f3f0e299;
	--pce-line-number: #53abc6;
	--pce-scrollbar: 0, 0%, 25%;
	--pce-bg-fold: #424242;
	--pce-ac-icon-class: #d67e00;
	--pce-ac-icon-enum: #d67e00;
	--pce-ac-icon-event: #d67e00;
	--pce-ac-icon-function: #652d90;
	--pce-ac-icon-interface: #007acc;
	--pce-ac-icon-variable: #007acc;
	--pce-ac-match: #0066bf;
	--pce-guide-indent: #1d333a40;
	--pce-tabstop: #0a326433;
	--pce-invisibles: #3333;
	--pce-selection: #ede7d4;
	color-scheme: light;
}

.pce-match {
	--pce-search-match: #edba8f;
}

.active-line {
	--pce-line-number: #0b216f;
}

.active-indent {
	--pce-guide-indent: #081e2580;
}

[class*="language-"] {
	color: #657b83;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #93a1a1;
}

.token.punctuation,
.token.attr-equals {
	color: #586e75;
}

.token.namespace {
	opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
	color: #268bd2;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.url,
.token.inserted {
	color: #2aa198;
}

.token.entity {
	color: #657b83;
	background: #eee8d5;
}

.token.atrule,
.token.attr-value,
.token.keyword {
	color: #859900;
}

.token.function,
.token.class-name {
	color: #b58900;
}

.token.regex,
.language-regex,
.token.important,
.token.variable {
	color: #cb4b16;
}

.token.important,
.token.bold {
	font-weight: 700;
}
.token.italic {
	font-style: italic;
}

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #0431fa;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #319331;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #7b3814;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #b9b9b9, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #57575740;
}
